import React, { useEffect, useMemo, useState } from "react";
import { formatDecimal } from "./CondicionesFinancieras";
import { formatTasa } from "./LiquidacionArchivos";
import { pagosApi } from "./pagosApi";

export const TIPO_TASA_LABELS = {
  DERIVADA_FISERV: "Derivada del descuento financiero Fiserv",
  TASA_FIJA_CONVERSOR: "Tasa fija del conversor (marca y fecha)",
  AJUSTE_AUTORIZADO_CREDITO_UN_PAGO: "Ajuste autorizado · crédito en un pago",
  EXCEPCION_ANTICIPO: "Excepción de anticipo",
  SIN_REGLA_VERIFICABLE: "Sin regla verificable",
  SIN_ANTICIPO: "Sin anticipo",
};

const APROBACION_LABELS = {
  SIN_PROPUESTA: "Sin propuesta",
  BORRADOR: "Borrador",
  SIMULADO: "Simulada",
  PENDIENTE_APROBACION: "Pendiente de aprobación",
  APROBADO_PARA_PRUEBAS: "Aprobada para pruebas",
  RECHAZADO: "Rechazada",
};

const formatFecha = (value) => {
  const [year, month, day] = String(value || "").slice(0, 10).split("-");
  return year && month && day ? `${day}/${month}/${year}` : "—";
};
const POR_PAGINA = 100;
const VACIO = { modo: "GRUPO", porcentaje: "", hasta: "", fuente: "", motivo: "", responsable: "" };
const TIPOS_PORCENTAJE = new Set(["TASA_ANTICIPO_CONVERSOR", "DEBITO_CREDITO"]);
const porcentajeRegla = (hipotesis) => {
  const valor = Number(hipotesis?.regla?.valor);
  return Number.isFinite(valor) ? String(Math.round(valor * 100000000) / 1000000).replace(".", ",") : "";
};

function Simulacion({ simulacion }) {
  const s = simulacion;
  return (
    <section aria-label="Simulación de anticipo">
      <h4 className="pagos-subheading">Simulación · {s.regla}</h4>
      <div className="pagos-summary pagos-summary--demo">
        <div className="pagos-summary-card"><span>Neto antes</span><strong>{s.netoAntes === null ? "Incompleto" : formatDecimal(s.netoAntes)}</strong><small>{s.incompletasAntes} incompletas · comparables {formatDecimal(s.netoAntesComparables)}</small></div>
        <div className="pagos-summary-card"><span>Neto después</span><strong>{s.netoDespues === null ? "Incompleto" : formatDecimal(s.netoDespues)}</strong><small>{s.incompletasDespues} incompletas · comparables {formatDecimal(s.netoDespuesComparables)}</small></div>
        <div className="pagos-summary-card"><span>Diferencia</span><strong>{s.diferencia === null ? "No calculable" : formatDecimal(s.diferencia)}</strong><small>{s.operacionesAfectadas} afectadas · {s.completadasPorLaRegla} completadas · {s.incompletadasPorLaRegla} incompletadas</small></div>
        <div className="pagos-summary-card"><span>FUR antes → después</span>
          <strong>{s.furAntes?.gruposBloqueados ?? "—"} → {s.furDespues?.gruposBloqueados ?? "—"} bloqueados</strong>
          <small>neto {s.furAntes?.netoElegible === null ? "bloqueado" : formatDecimal(s.furAntes?.netoElegible)} → {s.furDespues?.netoElegible === null ? "bloqueado" : formatDecimal(s.furDespues?.netoElegible)}</small></div>
      </div>
      {(s.reglasFaltantesDespues || []).length > 0 && <div className="pagos-alert pagos-alert--warning" role="status"><strong>Reglas que siguen faltando</strong>
        <ul>{s.reglasFaltantesDespues.map((item) => <li key={item}>{item}</li>)}</ul></div>}
      {(s.bloqueosDespues || []).length > 0 && <div className="pagos-alert pagos-alert--error" role="status"><strong>Bloqueos después de la regla</strong>
        <ul>{s.bloqueosDespues.map((item) => <li key={item}>{item}</li>)}</ul></div>}
      <div className="pagos-table-wrap"><table aria-label="Diferencias por comercio"><thead><tr><th>Comercio</th><th>CUIT</th><th>Operaciones</th><th>Neto antes</th><th>Neto después</th><th>Diferencia</th></tr></thead><tbody>
        {(s.porComercio || []).map((item) => (
          <tr key={`${item.cuit}-${item.nombreComercio}`}><td>{item.nombreComercio || "Sin beneficiario"}</td><td>{item.cuit || "—"}</td><td>{item.operaciones}</td>
            <td>{item.netoAntes === null ? "Incompleto" : formatDecimal(item.netoAntes)}</td><td>{item.netoDespues === null ? "Incompleto" : formatDecimal(item.netoDespues)}</td>
            <td>{item.diferencia === null ? "—" : formatDecimal(item.diferencia)}</td></tr>
        ))}
      </tbody></table></div>
      <div className="pagos-table-wrap"><table aria-label="Operaciones afectadas"><thead><tr>
        <th>Operación</th><th>Comercio</th><th>Tarjeta · cuotas</th><th>Bruto</th><th>Total Descuento</th><th>Anticipo</th><th>Neto</th><th>Pendiente</th>
      </tr></thead><tbody>
        {(s.detalle || []).map((op) => (
          <tr key={op.operacionId} className={op.netoDespues === null ? "pagos-row--review" : ""}>
            <td>{op.operacionId}<small className="pagos-cell-note">{op.terminal}</small></td><td>{op.comercio || "—"}<small className="pagos-cell-note">{op.cuit}</small></td>
            <td>{op.tarjeta} · {op.cuotas ?? "—"}</td><td>{formatDecimal(op.bruto)}</td>
            <td>{formatTasa(op.totalDescuentoAntes)} → {formatTasa(op.totalDescuentoDespues)}<small className="pagos-cell-note">{TIPO_TASA_LABELS[op.tipoTasaDespues] || op.tipoTasaDespues}</small></td>
            <td>{formatDecimal(op.anticipoAntes)} → {formatDecimal(op.anticipoDespues)}</td>
            <td>{op.netoAntes === null ? op.estadoAntes : formatDecimal(op.netoAntes)} → {op.netoDespues === null ? op.estadoDespues : formatDecimal(op.netoDespues)}</td>
            <td><small>{(op.incompletitudesDespues || []).join(" ") || "—"}</small></td>
          </tr>
        ))}
      </tbody></table></div>
      {s.detalleTruncado && <p className="pagos-cell-note">Se muestran las primeras operaciones afectadas.</p>}
      <p className="pagos-cell-note">Huella {String(s.huella).slice(0, 16)}… · motor {s.motorVersion} · corrida rev. {s.revision}</p>
    </section>
  );
}

/**
 * Anticipos y excepciones: sobre una corrida desde archivos, muestra cómo se obtuvo cada Total
 * Descuento, permite proponer tasas (por grupo o por operación de crédito en un pago), simularlas
 * con el motor y aprobarlas con otro usuario. Todo es para pruebas en ZocoPagos_Dev: la pantalla
 * sólo envía IDs y el porcentaje como texto.
 */
export default function AnticiposExcepciones({ token, corridaIdInicial = "", fechaInicial = "", compacto = false, onCorridaRecalculada }) {
  const [estado, setEstado] = useState(null);
  const [fecha, setFecha] = useState("");
  const [corridas, setCorridas] = useState([]);
  const [corridaId, setCorridaId] = useState("");
  const [panel, setPanel] = useState(null);
  const [seleccion, setSeleccion] = useState([]);
  const [form, setForm] = useState(VACIO);
  const [simulacion, setSimulacion] = useState(null);
  const [referenciasHistoricas, setReferenciasHistoricas] = useState([]);
  const [hipotesisHistorica, setHipotesisHistorica] = useState(null);
  const [decisiones, setDecisiones] = useState(null);
  const [propuestaHipotesis, setPropuestaHipotesis] = useState({ responsable: "", motivo: "" });
  const [edicionesDecision, setEdicionesDecision] = useState({});
  const [comentario, setComentario] = useState("");
  const [soloSinTasa, setSoloSinTasa] = useState(true);
  const [pagina, setPagina] = useState(0);
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");
  const [mensaje, setMensaje] = useState("");

  useEffect(() => {
    let vigente = true;
    Promise.resolve().then(() => pagosApi.estadoCondiciones(token))
      .then((response) => { if (vigente) setEstado(response || { habilitada: false }); })
      .catch((requestError) => { if (vigente) setEstado({ habilitada: false, motivo: requestError?.message }); });
    return () => { vigente = false; };
  }, [token]);

  useEffect(() => {
    if (!estado?.habilitada || !corridaIdInicial) return undefined;
    let vigente = true;
    setFecha(fechaInicial || ""); setCorridaId(corridaIdInicial); setSeleccion([]); setPagina(0); setError("");
    Promise.all([pagosApi.anticiposPanel(corridaIdInicial, token), pagosApi.anticiposHipotesis(corridaIdInicial, token)])
      .then(([response, pendientes]) => { if (vigente) { setPanel(response); setDecisiones(pendientes); } })
      .catch((requestError) => { if (vigente) setError(requestError?.message || "No se pudo abrir la liquidación."); });
    return () => { vigente = false; };
  }, [estado?.habilitada, corridaIdInicial, fechaInicial, token]);

  const ejecutar = async (clave, accion) => {
    setError(""); setMensaje(""); setLoading(clave);
    try {
      await accion();
    } catch (requestError) {
      setError(requestError?.message || "No se pudo completar la operación.");
    } finally {
      setLoading("");
    }
  };

  const abrir = async (id) => {
    setCorridaId(id); setSeleccion([]); setReferenciasHistoricas([]); setHipotesisHistorica(null); setDecisiones(null); setPagina(0);
    const [nuevoPanel, pendientes] = await Promise.all([pagosApi.anticiposPanel(id, token), pagosApi.anticiposHipotesis(id, token)]);
    setPanel(nuevoPanel); setDecisiones(pendientes);
  };

  const elegirFecha = (valor) => {
    setFecha(valor); setPanel(null); setSimulacion(null); setReferenciasHistoricas([]); setHipotesisHistorica(null); setDecisiones(null);
    if (valor) ejecutar("corridas", async () => setCorridas(await pagosApi.archivosCorridas(valor, token) || []));
  };

  const operaciones = useMemo(() => (panel?.operaciones || [])
    .filter((op) => !soloSinTasa || op.tipoTasa === "SIN_REGLA_VERIFICABLE" || op.ajustePermitido), [panel, soloSinTasa]);
  const visibles = operaciones.slice(pagina * POR_PAGINA, (pagina + 1) * POR_PAGINA);

  const seleccionarGrupo = (grupo) => {
    // Una regla general cubre todas las operaciones de la marca y el caso en la fecha (todos los planes).
    const ids = (panel.grupos || []).filter((item) => item.marca === grupo.marca && item.caso === grupo.caso && item.estado === grupo.estado)
      .flatMap((item) => item.operacionIds);
    setSeleccion(ids);
    setForm((actual) => ({ ...actual, modo: "GRUPO" }));
  };

  const alternar = (id) => {
    setSeleccion((actual) => (actual.includes(id) ? actual.filter((item) => item !== id) : [...actual, id]));
    setForm((actual) => ({ ...actual, modo: "OPERACION" }));
  };

  const actualizar = (campo, valor) => setForm((actual) => ({ ...actual, [campo]: valor }));
  const completo = seleccion.length > 0 && form.porcentaje.trim() && form.fuente.trim() && form.motivo.trim() && form.responsable.trim();

  const proponer = () => ejecutar("proponer", async () => {
    const creadas = await pagosApi.anticiposProponer(corridaId, {
      modo: form.modo, operacionIds: seleccion, porcentaje: form.porcentaje, hasta: form.hasta || null,
      fuente: form.fuente, motivo: form.motivo, responsable: form.responsable,
    }, token);
    setPanel(await pagosApi.anticiposPanel(corridaId, token));
    setSeleccion([]); setForm(VACIO);
    setMensaje(`${(creadas || []).length} propuesta(s) creada(s) en borrador. Simulalas antes de enviarlas a aprobación.`);
  });

  const simular = (regla) => ejecutar(`simular-${regla.id}`, async () => {
    const respuesta = await pagosApi.anticiposSimular(regla.id, corridaId, token);
    setSimulacion(respuesta.simulacion);
    setPanel(await pagosApi.anticiposPanel(corridaId, token));
  });

  const verificar = (regla) => ejecutar(`verificar-${regla.id}`, async () => {
    const respuesta = await pagosApi.anticiposVerificarSimulacion(regla.id, token);
    setSimulacion(respuesta.simulacion);
    setMensaje(respuesta.reproducible ? "La simulación registrada es reproducible (misma huella)." : "La simulación cambió: el catálogo o la corrida no son los mismos. Volvé a simular.");
  });

  const resolver = (regla, accion) => ejecutar(`${accion}-${regla.id}`, async () => {
    if (accion === "enviar") await pagosApi.anticiposEnviar(regla.id, token);
    if (accion === "aprobar") await pagosApi.anticiposAprobar(regla.id, comentario, token);
    if (accion === "rechazar") await pagosApi.anticiposRechazar(regla.id, comentario, token);
    setComentario("");
    setPanel(await pagosApi.anticiposPanel(corridaId, token));
  });

  const recalcular = () => ejecutar("recalcular", async () => {
    const revision = await pagosApi.anticiposRecalcularCorrida(corridaId, token);
    setCorridas(await pagosApi.archivosCorridas(fecha, token) || []);
    setSimulacion(null);
    await abrir(revision.id);
    if (onCorridaRecalculada) await onCorridaRecalculada(revision.id);
    setMensaje(revision.creada ? "Se creó una revisión nueva de la corrida. La anterior no se modificó." : "Sin cambios en las reglas aprobadas: se mantiene la revisión existente.");
  });

  const simularHipotesis = () => ejecutar("hipotesis", async () => {
    const respuesta = await pagosApi.anticiposSimularHipotesisHistorica(corridaId, referenciasHistoricas, token);
    setHipotesisHistorica(respuesta);
  });

  const analizarDecisiones = () => ejecutar("decisiones", async () => {
    setDecisiones(await pagosApi.anticiposHipotesis(corridaId, token));
  });

  const alternarReferencia = (id) => setReferenciasHistoricas((actual) => actual.includes(id) ? actual.filter((item) => item !== id) : [...actual, id]);

  const proponerHipotesis = (hipotesis) => ejecutar(`proponer-${hipotesis.id}`, async () => {
    await pagosApi.anticiposProponerHipotesis(corridaId, { hipotesisId: hipotesis.id, ...propuestaHipotesis }, token);
    setPanel(await pagosApi.anticiposPanel(corridaId, token));
    setDecisiones(await pagosApi.anticiposHipotesis(corridaId, token));
    setMensaje("Propuesta creada en borrador con la evidencia observada. Simulala, enviala y que la apruebe otro usuario.");
  });

  const edicionDecision = (hipotesis) => edicionesDecision[hipotesis.id] || {
    porcentaje: porcentajeRegla(hipotesis),
    fuente: hipotesis?.regla?.fuente || decisiones?.fuenteHistorica || "",
    motivo: "Confirmado por la operadora para este lote",
    responsable: "Operaciones",
  };
  const editarDecision = (hipotesis, campo, valor) => setEdicionesDecision((actual) => ({
    ...actual, [hipotesis.id]: { ...edicionDecision(hipotesis), [campo]: valor },
  }));
  const guardarAplicarDecision = (hipotesis) => ejecutar(`aplicar-${hipotesis.id}`, async () => {
    const datos = edicionDecision(hipotesis);
    const respuesta = await pagosApi.anticiposGuardarAplicarDecision(corridaId, {
      hipotesisId: hipotesis.id,
      porcentaje: TIPOS_PORCENTAJE.has(hipotesis.tipo) ? datos.porcentaje : null,
      fuente: datos.fuente, motivo: datos.motivo, responsable: datos.responsable,
    }, token);
    setMensaje("Decisión guardada y aplicada. La liquidación se recalculó y las operaciones resueltas dejaron de figurar como incompletas.");
    setSimulacion(respuesta.simulacion);
    if (onCorridaRecalculada) await onCorridaRecalculada(respuesta.revision.id);
    // El padre actualiza el resumen general, pero esta bandeja también debe recargarse.
    // De lo contrario conserva visualmente la decisión aplicada y parece que no guardó.
    await abrir(respuesta.revision.id);
    setEdicionesDecision({});
  });

  if (!estado) return <section className="pagos-panel" data-testid="anticipos-excepciones"><p>Cargando…</p></section>;
  if (!estado.habilitada) {
    return (
      <section className="pagos-panel" data-testid="anticipos-excepciones">
        <h2>Anticipos y excepciones</h2>
        <div className="pagos-alert pagos-alert--warning" role="status">La gestión de anticipos sólo funciona en el entorno aislado de desarrollo. {estado.motivo}</div>
      </section>
    );
  }

  const c = panel?.corrida;
  return (
    <section className="pagos-panel" aria-labelledby="pagos-anticipos-title" data-testid="anticipos-excepciones">
      {!compacto && <div className="pagos-section-heading">
        <div>
          <h2 id="pagos-anticipos-title">Anticipos y excepciones</h2>
          <p>Cómo se obtuvo el Total Descuento de cada operación, qué falta y qué tasas se proponen. Cada cambio se simula con el motor y lo aprueba otro usuario.</p>
        </div>
        <span className="pagos-status pagos-status--warning">Sólo pruebas · no activa tasas productivas</span>
      </div>}
      {error && <div className="pagos-alert pagos-alert--error" role="alert">{error}</div>}
      {mensaje && <div className="pagos-alert pagos-alert--info" role="status">{mensaje}</div>}

      {!compacto && <div className="pagos-filter-grid">
        <label className="pagos-date"><span>Fecha de liquidación</span>
          <input aria-label="Fecha de liquidación de anticipos" type="date" value={fecha} onChange={(event) => elegirFecha(event.target.value)} /></label>
      </div>}
      {!compacto && corridas.length > 0 && <div className="pagos-table-wrap"><table aria-label="Corridas para anticipos"><thead><tr>
        <th>Creada</th><th>Estado</th><th>Operaciones</th><th>Registró</th><th></th>
      </tr></thead><tbody>
        {corridas.map((item) => (
          <tr key={item.id} className={item.id === corridaId ? "is-active" : ""}><td>{String(item.creadoEn).replace("T", " ").slice(0, 16)}</td><td>{item.estado}</td>
            <td>{item.operaciones - item.incompletas}/{item.operaciones}</td><td>{item.creadoPor}</td>
            <td><button type="button" className="pagos-secondary" onClick={() => ejecutar("abrir", () => abrir(item.id))}>Abrir</button></td></tr>
        ))}
      </tbody></table></div>}

      {panel && <>
        {!compacto && <div className="pagos-section-heading">
          <div><h3>Liquidación {formatFecha(c.fechaPago)} · revisión {c.revision}</h3>
            <p>{c.operaciones} operaciones · {c.incompletas} incompletas · {c.estado}</p></div>
          <button type="button" className="pagos-secondary" disabled={loading === "recalcular"} onClick={recalcular}>
            {loading === "recalcular" ? "Recalculando…" : "Recalcular corrida (revisión nueva)"}</button>
        </div>}
        {!compacto && <div className="pagos-alert pagos-alert--info" role="note">{panel.ambito}</div>}

        {!compacto && <div className="pagos-summary pagos-summary--demo" aria-label="Tipos de tasa">
          {(panel.resumen || []).map((item) => (
            <div key={item.tipoTasa} className="pagos-summary-card"><span>{TIPO_TASA_LABELS[item.tipoTasa] || item.tipoTasa}</span><strong>{item.operaciones}</strong><small>{formatDecimal(item.bruto)}</small></div>
          ))}
        </div>}

        <section aria-label="Decisiones pendientes">
          <div className="pagos-section-heading">
            <div><h4 className="pagos-subheading">{compacto ? "Otras decisiones del día" : "Decisiones pendientes"}</h4>
              <p>{compacto ? "Confirmá el valor sugerido o editalo. Las operaciones de la tasa máxima ya resueltas arriba no se repiten acá." : "Sólo lo que necesita una persona. Para cada grupo se muestra qué hizo el circuito histórico con esas mismas operaciones."}</p></div>
            {!compacto && <button type="button" className="pagos-secondary" disabled={loading === "decisiones"} onClick={analizarDecisiones}>
              {loading === "decisiones" ? "Analizando…" : decisiones ? "Actualizar" : "Analizar decisiones pendientes"}</button>}
          </div>
          {decisiones && <>
            {!compacto && <div className="pagos-alert pagos-alert--warning" role="note"><strong>{decisiones.etiqueta}</strong><br />
              {decisiones.incompletas} operaciones incompletas; {decisiones.incompletasCubiertasPorHipotesisUniformes} tienen una hipótesis con valor único observado en {decisiones.fuenteHistorica}.</div>}
            {compacto && <div className="pagos-decision-queue" aria-label="Decisiones pendientes simplificadas">
              {(decisiones.decisiones || []).map((d, indice) => {
                const h = (decisiones.hipotesis || []).find((item) => item.id === d.hipotesisId);
                const uniforme = h?.estado === "UNIFORME";
                const datos = uniforme ? edicionDecision(h) : null;
                const aplicando = uniforme && loading === `aplicar-${h.id}`;
                return <article key={d.clave} className="pagos-decision-card">
                  <div className="pagos-decision-card__heading"><span>Pendiente {indice + 1} de {decisiones.decisiones.length}</span><strong>{d.descripcion}</strong></div>
                  <p><strong>{d.operaciones} operaciones</strong> · {formatDecimal(d.bruto)}</p>
                  {h ? <p>Valor observado: <strong>{(h.valoresObservados || []).join(", ")}</strong></p> : <p>{d.accion}</p>}
                  {uniforme ? <>
                    <div className="pagos-decision-card__action">
                      {TIPOS_PORCENTAJE.has(h.tipo) && <label><span>Valor a aplicar (%)</span><input aria-label={`Valor a aplicar ${d.descripcion}`} inputMode="decimal" value={datos.porcentaje} onChange={(event) => editarDecision(h, "porcentaje", event.target.value)} /></label>}
                      <button type="button" className="pagos-primary" disabled={aplicando || (TIPOS_PORCENTAJE.has(h.tipo) && !datos.porcentaje.trim()) || !datos.fuente.trim() || !datos.motivo.trim() || !datos.responsable.trim()}
                        onClick={() => guardarAplicarDecision(h)}>{aplicando ? "Continuando…" : "Confirmar y continuar"}</button>
                    </div>
                  </> : <div className="pagos-alert pagos-alert--info">No hay un único valor comprobado. {d.accion}</div>}
                </article>;
              })}
              {(decisiones.decisiones || []).length === 0 && <div className="pagos-alert pagos-alert--success">No quedan decisiones financieras pendientes para este lote.</div>}
            </div>}
            {!compacto && <div className="pagos-table-wrap"><table aria-label="Decisiones pendientes"><thead><tr>
              {!compacto && <th></th>}<th>Decisión</th><th>Operaciones</th><th>Observado en el histórico</th><th>Qué hacer</th><th>Confirmar o modificar</th>
            </tr></thead><tbody>{(decisiones.decisiones || []).map((d) => {
              const h = (decisiones.hipotesis || []).find((item) => item.id === d.hipotesisId);
              const uniforme = h?.estado === "UNIFORME";
              return (
                <tr key={d.clave} className="pagos-row--review">
                  {!compacto && <td>{uniforme && <input type="checkbox" aria-label={`Simular ${d.descripcion}`} checked={referenciasHistoricas.includes(h.id)} onChange={() => alternarReferencia(h.id)} />}</td>}
                  <td>{d.descripcion}<small className="pagos-cell-note">{d.tipo}</small></td>
                  <td>{d.operaciones}<small className="pagos-cell-note">{formatDecimal(d.bruto)}</small></td>
                  <td>{h ? <>{h.estado}: {(h.valoresObservados || []).join(", ")}<small className="pagos-cell-note">{h.evidencia}</small></> : <small>{d.evidencia}</small>}</td>
                  <td>{d.accion}<small className="pagos-cell-note">{d.responsable}</small></td>
                  <td>{uniforme ? (() => {
                    const datos = edicionDecision(h);
                    const aplicando = loading === `aplicar-${h.id}`;
                    return <div className="pagos-decision-editor">
                      {TIPOS_PORCENTAJE.has(h.tipo)
                        ? <label><span>Valor a aplicar (%)</span><input aria-label={`Valor a aplicar ${d.descripcion}`} inputMode="decimal" value={datos.porcentaje} onChange={(event) => editarDecision(h, "porcentaje", event.target.value)} /></label>
                        : <p><strong>Convención:</strong> 1 cuota si pasaron más de 2 días hábiles; si no, 3.</p>}
                      <label><span>Fuente</span><input aria-label={`Fuente ${d.descripcion}`} value={datos.fuente} onChange={(event) => editarDecision(h, "fuente", event.target.value)} /></label>
                      <label><span>Motivo</span><input aria-label={`Motivo ${d.descripcion}`} value={datos.motivo} onChange={(event) => editarDecision(h, "motivo", event.target.value)} /></label>
                      <label><span>Responsable</span><input aria-label={`Responsable ${d.descripcion}`} value={datos.responsable} onChange={(event) => editarDecision(h, "responsable", event.target.value)} /></label>
                      <button type="button" className="pagos-primary" disabled={aplicando || (TIPOS_PORCENTAJE.has(h.tipo) && !datos.porcentaje.trim()) || !datos.fuente.trim() || !datos.motivo.trim() || !datos.responsable.trim()}
                        onClick={() => guardarAplicarDecision(h)}>{aplicando ? "Continuando…" : "Confirmar y continuar"}</button>
                    </div>;
                  })() : <small>No hay un valor único comprobado; requiere completar la fuente.</small>}</td>
                </tr>
              );
            })}</tbody></table></div>}
            {!compacto && <div className="pagos-filter-grid">
              <label><span>Responsable de la propuesta</span><input aria-label="Responsable de la propuesta desde hipótesis" value={propuestaHipotesis.responsable}
                onChange={(event) => setPropuestaHipotesis((actual) => ({ ...actual, responsable: event.target.value }))} /></label>
              <label><span>Motivo</span><input aria-label="Motivo de la propuesta desde hipótesis" value={propuestaHipotesis.motivo}
                onChange={(event) => setPropuestaHipotesis((actual) => ({ ...actual, motivo: event.target.value }))} /></label>
            </div>}
            {!compacto && <button type="button" className="pagos-primary" disabled={referenciasHistoricas.length === 0 || loading === "hipotesis"} onClick={simularHipotesis}>
              {loading === "hipotesis" ? "Simulando…" : `Simular hipótesis seleccionadas (${referenciasHistoricas.length})`}</button>
            }
          </>}
        </section>

        <details className="pagos-advanced-detail pagos-anticipos-technical" open={!compacto}>
          <summary>{compacto ? "Ver trazabilidad y herramientas técnicas" : "Detalle técnico de anticipos"}</summary>
        {(panel.referenciasHistoricas || []).length > 0 && <section className="pagos-historical-hypothesis" aria-label="Simular con tasas históricas">
          <div className="pagos-alert pagos-alert--warning" role="note"><strong>{panel.etiquetaHipotesisHistorica}</strong><br />
            Las referencias se obtuvieron del Conversor de esa fecha. No se seleccionan solas, no crean reglas y no habilitan pagos.</div>
          <h4 className="pagos-subheading">Simular con tasas históricas</h4>
          <div className="pagos-table-wrap"><table aria-label="Referencias históricas de anticipo"><thead><tr>
            <th></th><th>Marca · plan</th><th>Condición</th><th>Tasa</th><th>Operaciones pendientes</th><th>Fuente exacta</th><th>Fórmula / evidencia</th>
          </tr></thead><tbody>{panel.referenciasHistoricas.map(({ referencia, operacionesAfectadas }) => (
            <tr key={referencia.id} className={operacionesAfectadas > 0 ? "pagos-row--review" : ""}>
              <td><input type="checkbox" aria-label={`Usar referencia ${referencia.marca} ${referencia.plan}`}
                disabled={operacionesAfectadas === 0} checked={referenciasHistoricas.includes(referencia.id)}
                onChange={() => setReferenciasHistoricas((actual) => actual.includes(referencia.id) ? actual.filter((id) => id !== referencia.id) : [...actual, referencia.id])} /></td>
              <td>{referencia.marca} · {referencia.plan ?? "—"}</td><td>{referencia.condicionComercial}</td><td>{formatTasa(referencia.tasa)}</td>
              <td>{operacionesAfectadas}</td><td><small>{referencia.archivo}<br />{referencia.hoja}!{referencia.celdas}</small></td>
              <td><small>{referencia.formula}<br />{referencia.evidencia}</small></td>
            </tr>
          ))}</tbody></table></div>
          <button type="button" className="pagos-primary" disabled={referenciasHistoricas.length === 0 || loading === "hipotesis"} onClick={simularHipotesis}>
            {loading === "hipotesis" ? "Simulando…" : `Simular hipótesis (${referenciasHistoricas.length})`}</button>
        </section>}

        {hipotesisHistorica && <section aria-label="Resultado de hipótesis histórica">
          <div className="pagos-alert pagos-alert--error" role="status"><strong>{hipotesisHistorica.etiqueta}</strong><br />{hipotesisHistorica.advertencia}</div>
          <Simulacion simulacion={hipotesisHistorica.impacto} />
          {hipotesisHistorica.comparacionHistorica && <div className="pagos-summary pagos-summary--demo" aria-label="Comparación con liquidación histórica">
            <div className="pagos-summary-card"><span>Comparación histórica</span><strong>{hipotesisHistorica.comparacionHistorica.veredicto}</strong><small>No convierte la hipótesis en regla aprobada</small></div>
            <div className="pagos-summary-card"><span>Operaciones</span><strong>{hipotesisHistorica.comparacionHistorica.operacionesMotor} / {hipotesisHistorica.comparacionHistorica.operacionesHistorico}</strong><small>{hipotesisHistorica.comparacionHistorica.soloHistorico} sólo en el histórico</small></div>
            <div className="pagos-summary-card"><span>Netos comparados</span><strong>{hipotesisHistorica.comparacionHistorica.netosExactos} exactos</strong><small>{hipotesisHistorica.comparacionHistorica.netosDistintos} distintos</small></div>
          </div>}
        </section>}

        <h4 className="pagos-subheading">Por marca, plan y caso</h4>
        <div className="pagos-table-wrap"><table aria-label="Anticipos por grupo"><thead><tr>
          <th>Marca · plan</th><th>Caso</th><th>Tipo de tasa</th><th>Operaciones</th><th>Anticipo original (Fiserv)</th><th>Tasa vigente</th><th>Sin tasa</th><th>Excepciones</th><th>Fuente</th><th>Aprobación</th><th></th>
        </tr></thead><tbody>
          {(panel.grupos || []).map((g) => (
            <tr key={`${g.marca}-${g.caso}-${g.plan}-${g.estado}`} className={g.sinTasa > 0 || g.excepciones > 0 ? "pagos-row--review" : ""}>
              <td>{g.marca} · {g.plan ?? "—"}<small className="pagos-cell-note">{(g.familias || []).join(", ")}</small></td>
              <td>{g.caso}{g.parametro && <small className="pagos-cell-note">{g.parametro}</small>}</td>
              <td>{TIPO_TASA_LABELS[g.tipoTasa] || g.tipoTasa}</td>
              <td>{g.operaciones}<small className="pagos-cell-note">{formatDecimal(g.bruto)}</small></td>
              <td>{formatDecimal(g.anticipoOriginalFiserv)}</td>
              <td>{(g.tasasVigentes || []).length === 0 ? "—" : g.tasasDistintas > 1 ? `${g.tasasDistintas} tasas (por operación)` : formatTasa(g.tasasVigentes[0])}</td>
              <td>{g.sinTasa}</td><td>{g.excepciones}</td>
              <td><small>{g.fuente || "—"}</small>{g.bloqueo && <small className="pagos-cell-note">{g.bloqueo}</small>}{!g.bloqueo && g.motivo && <small className="pagos-cell-note">{g.motivo}</small>}</td>
              <td>{g.parametro ? (APROBACION_LABELS[g.estadoAprobacion] || g.estadoAprobacion) : "—"}</td>
              <td>{g.propuestaGrupo && <button type="button" className="pagos-secondary" onClick={() => seleccionarGrupo(g)}>Seleccionar grupo</button>}</td>
            </tr>
          ))}
        </tbody></table></div>

        <h4 className="pagos-subheading">Operaciones ({operaciones.length})</h4>
        <div className="pagos-filter-grid">
          <label><input type="checkbox" aria-label="Sólo pendientes o ajustables" checked={soloSinTasa} onChange={(event) => { setSoloSinTasa(event.target.checked); setPagina(0); }} /> Sólo sin tasa o con ajuste posible</label>
          <span className="pagos-cell-note">{seleccion.length} seleccionadas · página {pagina + 1} de {Math.max(1, Math.ceil(operaciones.length / POR_PAGINA))}</span>
          <button type="button" className="pagos-secondary" disabled={pagina === 0} onClick={() => setPagina(pagina - 1)}>Anterior</button>
          <button type="button" className="pagos-secondary" disabled={(pagina + 1) * POR_PAGINA >= operaciones.length} onClick={() => setPagina(pagina + 1)}>Siguiente</button>
        </div>
        <div className="pagos-table-wrap"><table aria-label="Operaciones de anticipo"><thead><tr>
          <th></th><th>Operación</th><th>Terminal · cupón</th><th>Fecha</th><th>Tarjeta · trx · cuotas</th><th>Bruto</th><th>Dto. financ. Fiserv</th><th>Total Descuento</th><th>Tipo · fuente</th>
        </tr></thead><tbody>
          {visibles.map((op) => (
            <tr key={op.id} className={op.tipoTasa === "SIN_REGLA_VERIFICABLE" ? "pagos-row--review" : ""}>
              <td>{op.ajustePermitido && <input type="checkbox" aria-label={`Seleccionar ${op.id}`} checked={seleccion.includes(op.id)} onChange={() => alternar(op.id)} />}</td>
              <td>{op.id}</td><td>{op.terminal} · {op.cupon}</td><td>{formatFecha(op.fechaOperacion)}</td>
              <td>{op.tarjeta} · {op.transaccionFiserv} · {op.cuotas ?? "—"}</td><td>{formatDecimal(op.bruto)}</td><td>{formatDecimal(op.anticipoOriginalFiserv)}</td>
              <td>{op.totalDescuento === null || op.totalDescuento === undefined ? "—" : formatTasa(op.totalDescuento)}</td>
              <td>{TIPO_TASA_LABELS[op.tipoTasa] || op.tipoTasa}<small className="pagos-cell-note">{op.fuente || op.motivo || ""}</small></td>
            </tr>
          ))}
        </tbody></table></div>

        <h4 className="pagos-subheading">Proponer tasa</h4>
        <p className="pagos-cell-note">En grupo: una regla por marca y caso, vigente en la fecha de pago, para todas sus operaciones. Individual: sólo crédito en un pago. No hay valores por defecto.</p>
        <div className="pagos-filter-grid" aria-label="Propuesta de tasa">
          <label className="pagos-date"><span>Modo</span>
            <select aria-label="Modo de propuesta" value={form.modo} onChange={(event) => actualizar("modo", event.target.value)}>
              <option value="GRUPO">Grupo (marca y caso)</option><option value="OPERACION">Por operación</option>
            </select></label>
          <label className="pagos-date"><span>Total Descuento (%)</span>
            <input aria-label="Porcentaje propuesto" inputMode="decimal" placeholder="7,11" value={form.porcentaje} onChange={(event) => actualizar("porcentaje", event.target.value)} /></label>
          <label className="pagos-date"><span>Vigente hasta (opcional)</span>
            <input aria-label="Vigente hasta" type="date" value={form.hasta} onChange={(event) => actualizar("hasta", event.target.value)} /></label>
          <label className="pagos-date"><span>Fuente</span>
            <input aria-label="Fuente de la tasa" value={form.fuente} placeholder="Conversor del día, hoja Visa!O" onChange={(event) => actualizar("fuente", event.target.value)} /></label>
          <label className="pagos-date"><span>Motivo</span>
            <input aria-label="Motivo de la propuesta" value={form.motivo} onChange={(event) => actualizar("motivo", event.target.value)} /></label>
          <label className="pagos-date"><span>Responsable</span>
            <input aria-label="Responsable" value={form.responsable} onChange={(event) => actualizar("responsable", event.target.value)} /></label>
          <button type="button" className="pagos-primary" disabled={!completo || loading === "proponer"} onClick={proponer}>
            {loading === "proponer" ? "Proponiendo…" : `Proponer tasa (${seleccion.length})`}</button>
        </div>

        <h4 className="pagos-subheading">Propuestas y aprobaciones</h4>
        {(panel.propuestas || []).length === 0 ? <p className="pagos-cell-note">No hay reglas de Total Descuento para esta fecha.</p> : <>
          <label className="pagos-date"><span>Comentario de aprobación o rechazo</span>
            <input aria-label="Comentario de resolución" value={comentario} onChange={(event) => setComentario(event.target.value)} /></label>
          <div className="pagos-table-wrap"><table aria-label="Propuestas de anticipo"><thead><tr>
            <th>Regla</th><th>Tasa</th><th>Vigencia</th><th>Estado</th><th>Propuso · resolvió</th><th>Motivo</th><th>Acciones</th>
          </tr></thead><tbody>
            {panel.propuestas.map((regla) => (
              <tr key={regla.id}>
                <td>{regla.alcance === "OPERACION" ? regla.sujeto : regla.parametro}<small className="pagos-cell-note">v{regla.version}</small></td>
                <td>{formatTasa(regla.valor)}</td><td>{formatFecha(regla.desde)} – {regla.hasta ? formatFecha(regla.hasta) : "sin fin"}</td>
                <td>{APROBACION_LABELS[regla.estado] || regla.estado}</td>
                <td>{regla.creadoPor}{regla.resueltoPor && <small className="pagos-cell-note">{regla.resueltoPor}</small>}</td>
                <td><small>{regla.motivo}</small><small className="pagos-cell-note">{regla.fuente}</small></td>
                <td>
                  {(regla.estado === "BORRADOR" || regla.estado === "SIMULADO") && <button type="button" className="pagos-secondary" onClick={() => simular(regla)}>Simular</button>}
                  {regla.estado === "SIMULADO" && <button type="button" className="pagos-secondary" onClick={() => resolver(regla, "enviar")}>Enviar a aprobación</button>}
                  {regla.simulacionCorridaArchivosId && <button type="button" className="pagos-secondary" onClick={() => verificar(regla)}>Verificar simulación</button>}
                  {regla.estado === "PENDIENTE_APROBACION" && <>
                    <button type="button" className="pagos-primary" onClick={() => resolver(regla, "aprobar")}>Aprobar para pruebas</button>
                    <button type="button" className="pagos-secondary" onClick={() => resolver(regla, "rechazar")}>Rechazar</button>
                  </>}
                </td>
              </tr>
            ))}
          </tbody></table></div>
          <p className="pagos-cell-note">Quien propone no puede aprobar ni rechazar. Aprobar habilita la tasa sólo para pruebas; para que impacte en la corrida hay que recalcularla (revisión nueva).</p>
        </>}

        {simulacion && <Simulacion simulacion={simulacion} />}

        <h4 className="pagos-subheading">Excepciones de anticipo pendientes de reingreso</h4>
        {(panel.excepcionesPendientes || []).length === 0 ? <p className="pagos-cell-note">Sin excepciones pendientes.</p> : (
          <div className="pagos-table-wrap"><table aria-label="Excepciones pendientes"><thead><tr>
            <th>Operación</th><th>Comercio</th><th>Lote de origen</th><th>Fecha operación</th><th>Bruto</th><th>TD base</th><th>Neto de reingreso</th><th>Reingreso estimado</th><th>Control de pago / duplicado</th>
          </tr></thead><tbody>
            {panel.excepcionesPendientes.map((item) => (
              <tr key={`${item.operacionId}-${item.fechaLoteOrigen}`} className={item.vencida ? "pagos-row--review" : ""}>
                <td>{item.operacionId}<small className="pagos-cell-note">{item.terminal} · {item.tarjeta}</small></td>
                <td>{item.nombreComercio || "—"}<small className="pagos-cell-note">{item.cuit}</small></td>
                <td>{formatFecha(item.fechaLoteOrigen)}{item.propia ? " · este lote" : ""}</td><td>{formatFecha(item.fechaOperacion)}</td>
                <td>{formatDecimal(item.bruto)}</td><td>{formatTasa(item.totalDescuentoBase)}</td>
                <td>{item.netoReingreso === null ? "No calculado" : formatDecimal(item.netoReingreso)}</td>
                <td>{formatFecha(item.fechaReingresoEstimada)}{item.debeReingresarEnEsteLote ? " · DEBÍA REINGRESAR" : item.vencida ? " · VENCIDA" : ""}<small className="pagos-cell-note">{item.estadoEstimacion} · {item.heredada ? "heredada" : "originada en este lote"}</small></td>
                <td><small>{item.estadoPagoPrevio}<br />{item.riesgoDuplicado}</small></td>
              </tr>
            ))}
          </tbody></table></div>
        )}

        {(panel.representaciones || []).length > 0 && <>
          <h4 className="pagos-subheading">Representaciones y transacciones sin regla</h4>
          <div className="pagos-table-wrap"><table aria-label="Representaciones"><thead><tr>
            <th>Transacción</th><th>Archivo</th><th>Terminal</th><th>Fecha</th><th>Importe</th><th>Tratamiento</th><th>Antecedentes históricos</th>
          </tr></thead><tbody>
            {panel.representaciones.map((item) => (
              <tr key={`${item.archivo}-${item.pagina}-${item.terminal}-${item.importe}`} className="pagos-row--review">
                <td>{item.transaccion}</td><td>{item.archivo}<small className="pagos-cell-note">pág. {item.pagina}</small></td><td>{item.terminal || "—"}</td>
                <td>{formatFecha(item.fechaOperacion)}</td><td>{formatDecimal(item.importe)}</td><td><small>{item.tratamiento}</small></td>
                <td>{(item.antecedentes || []).length === 0 ? "Sin antecedentes" : <ul>{item.antecedentes.map((ant) => (
                  <li key={`${ant.fechaPago}-${ant.estado}-${ant.cupon}`}>{formatFecha(ant.fechaPago)} · {ant.estado} · cupón {ant.cupon} · neto {formatDecimal(ant.neto)} · {ant.nombreComercio}</li>
                ))}</ul>}</td>
              </tr>
            ))}
          </tbody></table></div>
        </>}

        <h4 className="pagos-subheading">Revisiones de la corrida</h4>
        <div className="pagos-table-wrap"><table aria-label="Revisiones de la corrida"><thead><tr><th>Revisión</th><th>Creada</th><th>Estado</th><th>Incompletas</th><th>Resueltas / nuevas</th><th>Registró</th></tr></thead><tbody>
          {(panel.revisiones || []).map((item) => (
            <tr key={item.id} className={item.id === c.id ? "is-active" : ""}><td>{item.revision}</td><td>{String(item.creadoEn).replace("T", " ").slice(0, 16)}</td>
              <td>{item.estado}</td><td>{item.incompletas}/{item.operaciones}</td><td>{(() => { const cambio = (panel.comparacionRevisiones || []).find((x) => x.id === item.id); return cambio?.revisionAnterior == null ? "Revisión inicial" : `${cambio.resueltas} resueltas · ${cambio.nuevosBloqueos} nuevas`; })()}</td><td>{item.creadoPor}</td></tr>
          ))}
        </tbody></table></div>

        <h4 className="pagos-subheading">Investigación pendiente</h4>
        <div className="pagos-table-wrap"><table aria-label="Investigación pendiente"><thead><tr><th>Tema</th><th>Estado</th><th>Evidencia</th><th>Falta</th></tr></thead><tbody>
          {(panel.investigacion || []).map((item) => (
            <tr key={item.tema}><td>{item.tema}</td><td>{item.estado}</td><td><small>{item.evidencia}</small></td><td><small>{item.falta}</small></td></tr>
          ))}
        </tbody></table></div>
        </details>
      </>}
    </section>
  );
}
